import { useInstantSearch } from 'react-instantsearch';

const useAlgoliaHits = () => {
  // get the scoped results & query
  const { scopedResults } = useInstantSearch();
  try {
    const totalHits = scopedResults.reduce((acc, { results }) => {
      if (results) {
        return acc + results.nbHits;
      }
      return acc;
    }, 0);
    const hitsDisplayed = scopedResults.reduce((acc, { results }) => {
      if (results) {
        if (results.nbPages === results.page + 1) {
          return acc + results.nbHits;
        } else {
          return acc + (results.page + 1) * results.hitsPerPage;
        }
      }
      return acc;
    }, 0);

    return { totalHits, hitsDisplayed };
  } catch (e) {
    return { totalHits: 0, hitsDisplayed: 0 };
  }
};

export default useAlgoliaHits;
